import { useRef, useEffect, DependencyList, EffectCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { requests } from "../services/http-common";

export function useEffectWithoutMount(
  callback: EffectCallback,
  dependencies: DependencyList
): void {
  const hasMountedRef = useRef(false);

  useEffect(() => {
    if (hasMountedRef.current) {
      callback();
    } else {
      hasMountedRef.current = true;
    }
  }, dependencies);
}

export function useUSAStates() {
  // for now we only have USA, later maybe will be changed dynamically for other countries
  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => {
      return requests.get("/administrative-division/usa/states");
    },
    select: (data: { name: string }[]) => {
      return data.map((s) => ({ label: s.name, value: s.name }));
    },
  });

  return states;
}
